export const usersReducer = (state = { loading: false, resultuser: null, users: [], user: null, total: 0, dashboard: null, dashboardError: null, odooError: null, invoices: [], invoicesLoading: false, invoicesError: null, documents: [], profileUpdating: false, profileUpdateError: null, profileUpdateSuccess: null, notifications: [], notificationsLoading: false, notificationsError: null, unreadCount: 0, noticeboard: [], noticeboardLoading: false, noticeboardError: null, sentMessages: [], sentLoading: false, sentError: null, thread: [], threadLoading: false, threadError: null, tutorMessageSending: false, tutorMessageSuccess: null, tutorMessageError: null, avatar: null, avatarUploading: false, selectedStudentId: localStorage.getItem('selectedStudentId') || null, followUp: [], followUpLoading: false, followUpError: null, invoicesByStudent: {}, invoicesAllLoading: false }, action) => {
    switch (action.type) {
        case 'USER_GETALL_SUCCESS':
            return {
                ...state,
                loading: false,
                users: action.payload.users,
                total: action.payload.total
            }
        case 'USER_GET_SUCCESS':
            return {
                ...state,
                loading: false,
                user: action.payload.user
            }
        case 'USER_ADD_SUCCESS':
            return {
                ...state,
                loading: false,
                resultuser: action.payload.message,
                user: action.payload.user,
                users: [...state.users, action.payload.user],
            }
        case 'USER_EDIT_SUCCESS':
            if (action.payload.user) {
                return {
                    ...state,
                    loading: false,
                    resultuser: action.payload.message,
                    user: action.payload.user,
                    users: state.users.map(user => user._id === action.payload.user._id ? action.payload.user : user),
                }
            } else {
                return {
                    ...state,
                    loading: false,
                    resultuser: action.payload
                }
            }
        case 'USER_ENABLEDISABLE_SUCCESS':
            return {
                ...state,
                loading: false,
                user: { ...state.user, active: action.payload.stateuser },
                users: state.users.map(user => user._id === action.payload.idUser ? { ...user, active: action.payload.stateuser } : user),
                resultuser: action.payload.message
            }
        case 'TEACHER_IMPORT_SUCCESS':
            return {
                ...state,
                loading: false,
                resultuser: action.payload.message
            }
        case 'STUDENT_IMPORT_SUCCESS':
            return {
                ...state,
                loading: false,
                resultuser: action.payload.message
            }
        case 'STUDENT_GET_SUCCESS':
            return {
                ...state,
                loading: false,
                user: action.payload,
                odooError: null
            }
        case 'STUDENT_GET_ERROR':
            return {
                ...state,
                loading: false,
                user: null,
                odooError: action.payload
            }
        case 'DASHBOARD_ME_SUCCESS': {
            const students = action.payload?.students || []
            let selectedStudentId = state.selectedStudentId
            if (selectedStudentId && !students.some(s => s.id === selectedStudentId)) selectedStudentId = null
            if (!selectedStudentId && students.length > 0) selectedStudentId = students[0].id
            if (selectedStudentId) localStorage.setItem('selectedStudentId', selectedStudentId)
            return {
                ...state,
                loading: false,
                dashboard: action.payload,
                dashboardError: null,
                avatar: action.payload?.user?.avatar || state.avatar || null,
                selectedStudentId
            }
        }
        case 'DASHBOARD_ME_ERROR':
            return {
                ...state,
                loading: false,
                dashboard: null,
                dashboardError: action.payload
            }
        case 'INVOICES_LOADING':
            return {
                ...state,
                invoicesLoading: true,
                invoicesError: null
            }
        case 'INVOICES_SUCCESS':
            return {
                ...state,
                invoicesLoading: false,
                invoices: action.payload.invoices || [],
                documents: action.payload.documents || [],
                invoicesError: null
            }
        case 'INVOICES_ALL_LOADING':
            return {
                ...state,
                invoicesAllLoading: true,
                invoicesError: null
            }
        case 'INVOICES_ALL_SUCCESS':
            return {
                ...state,
                invoicesAllLoading: false,
                invoicesByStudent: action.payload || {},
                invoicesError: null
            }
        case 'INVOICES_ALL_ERROR':
            return {
                ...state,
                invoicesAllLoading: false,
                invoicesByStudent: {},
                invoicesError: action.payload
            }
        case 'INVOICES_ERROR':
            return {
                ...state,
                invoicesLoading: false,
                invoices: [],
                documents: [],
                invoicesError: action.payload
            }
        case 'PROFILE_UPDATING':
            return {
                ...state,
                profileUpdating: true,
                profileUpdateError: null,
                profileUpdateSuccess: null
            }
        case 'PROFILE_UPDATE_SUCCESS':
            return {
                ...state,
                profileUpdating: false,
                profileUpdateSuccess: action.payload,
                profileUpdateError: null
            }
        case 'PROFILE_UPDATE_ERROR':
            return {
                ...state,
                profileUpdating: false,
                profileUpdateSuccess: null,
                profileUpdateError: action.payload
            }
        case 'NOTIFICATIONS_LOADING':
            return {
                ...state,
                notificationsLoading: true,
                notificationsError: null
            }
        case 'NOTIFICATIONS_SUCCESS':
            return {
                ...state,
                notificationsLoading: false,
                notifications: action.payload.notifications || [],
                unreadCount: action.payload.unreadCount || 0,
                notificationsError: null
            }
        case 'NOTIFICATIONS_ERROR':
            return {
                ...state,
                notificationsLoading: false,
                notifications: [],
                unreadCount: 0,
                notificationsError: action.payload
            }
        case 'NOTICEBOARD_LOADING':
            return {
                ...state,
                noticeboardLoading: true,
                noticeboardError: null
            }
        case 'NOTICEBOARD_SUCCESS':
            return {
                ...state,
                noticeboardLoading: false,
                noticeboard: action.payload || [],
                noticeboardError: null
            }
        case 'NOTICEBOARD_ERROR':
            return {
                ...state,
                noticeboardLoading: false,
                noticeboard: [],
                noticeboardError: action.payload
            }
        case 'SENT_LOADING':
            return {
                ...state,
                sentLoading: true,
                sentError: null
            }
        case 'SENT_SUCCESS':
            return {
                ...state,
                sentLoading: false,
                sentMessages: action.payload || [],
                sentError: null
            }
        case 'SENT_ERROR':
            return {
                ...state,
                sentLoading: false,
                sentMessages: [],
                sentError: action.payload
            }
        case 'THREAD_LOADING':
            return {
                ...state,
                threadLoading: true,
                threadError: null
            }
        case 'THREAD_SUCCESS':
            return {
                ...state,
                threadLoading: false,
                thread: action.payload || [],
                threadError: null
            }
        case 'THREAD_ERROR':
            return {
                ...state,
                threadLoading: false,
                thread: [],
                threadError: action.payload
            }
        case 'THREAD_RESET':
            return {
                ...state,
                thread: [],
                threadLoading: false,
                threadError: null
            }
        case 'TUTOR_MESSAGE_SENDING':
            return {
                ...state,
                tutorMessageSending: true,
                tutorMessageSuccess: null,
                tutorMessageError: null
            }
        case 'TUTOR_MESSAGE_SUCCESS':
            return {
                ...state,
                tutorMessageSending: false,
                tutorMessageSuccess: action.payload,
                tutorMessageError: null
            }
        case 'TUTOR_MESSAGE_ERROR':
            return {
                ...state,
                tutorMessageSending: false,
                tutorMessageSuccess: null,
                tutorMessageError: action.payload
            }
        case 'TUTOR_MESSAGE_RESET':
            return {
                ...state,
                tutorMessageSending: false,
                tutorMessageSuccess: null,
                tutorMessageError: null
            }
        case 'AVATAR_UPLOADING':
            return {
                ...state,
                avatarUploading: true
            }
        case 'AVATAR_SUCCESS':
            return {
                ...state,
                avatarUploading: false,
                avatar: action.payload
            }
        case 'AVATAR_ERROR':
            return {
                ...state,
                avatarUploading: false
            }
        case 'USER_RESET_RESULT':
            return {
                ...state,
                resultuser: null
            }
        case 'SELECT_STUDENT':
            if (action.payload) {
                localStorage.setItem('selectedStudentId', action.payload)
            } else {
                localStorage.removeItem('selectedStudentId')
            }
            return {
                ...state,
                selectedStudentId: action.payload || null
            }
        case 'FOLLOWUP_LOADING':
            return {
                ...state,
                followUpLoading: true,
                followUpError: null
            }
        case 'FOLLOWUP_SUCCESS':
            return {
                ...state,
                followUpLoading: false,
                followUp: action.payload || [],
                followUpError: null
            }
        case 'FOLLOWUP_ERROR':
            return {
                ...state,
                followUpLoading: false,
                followUp: [],
                followUpError: action.payload
            }
        case 'USER_LOADING':
            return {
                ...state,
                loading: true
            }
        case 'USER_NOT_LOADING':
            return {
                ...state,
                loading: false
            }
        default:
            return state
    }
}

